import * as React from 'react'
export interface dashStyleType {
  /** width of dash */
  width?: string
  /** height of dash */
  height?: string
  /** gap between steps */
  gap?: string
}
export interface StepperContextType {
  activeStep: number
  alternativeLabel: boolean
  connector: React.ReactNode
  nonLinear: boolean
  orientation: 'horizontal' | 'vertical'
  variant: 'standard' | 'dash'
  dashStyle: dashStyleType
}

/**
 * Provides information about the current step in Stepper.
 */
const StepperContext = React.createContext<StepperContextType | {}>({})

StepperContext.displayName = 'StepperContext'

/**
 * Returns the current StepperContext or an empty object if no StepperContext
 * has been defined in the component tree.
 */
export function useStepperContext(): StepperContextType | {} {
  return React.useContext(StepperContext)
}

export default StepperContext
